import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Toast as ToastBS } from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import * as style from './Toast.module.scss'
import SuccessModal from './SuccessModal'
import { ToastContext } from '../../context/toastContext'

export default function Toast() {
  const [show, setShow] = useState(true)
  const { error, setError, setSuccess, success } = useContext(ToastContext)

  useEffect(() => {
    if (!error && !success) return

    setShow(true)
    const timeout = setTimeout(() => {
      if (error !== null) setError(null)
      if (success !== null) setSuccess(null)
    }, 10000)

    return () => clearTimeout(timeout)
  }, [error, success, setError, setSuccess])

  const errorPayload = useMemo(() => {
    if (!error) return null
    if (typeof error === 'string') return { message: error, actions: [] }
    // ожидаем { message, actions? }
    return { message: error.message || 'произошла ошибка', actions: error.actions || [] }
  }, [error])

  return (
    <>
      {errorPayload && (
        <ToastBS
          className={style.toast}
          onClose={() => {
            setShow(false)
            setError(null)
          }}
          show={show}
          bg={'danger'}
          data-bs-theme="dark"
        >
          <ToastBS.Header>
            <h6 className={'w-100'}>Ошибка</h6>
          </ToastBS.Header>

          <ToastBS.Body className={'text-light'}>
            <div>{errorPayload.message}</div>

            {errorPayload.actions?.length > 0 && (
              <div className="d-flex gap-2 mt-3">
                {errorPayload.actions.map((a, idx) => {
                  const variant = a.variant === 'primary' ? 'light' : 'outline-light'

                  if (a.href) {
                    return (
                      <Button
                        key={idx}
                        as="a"
                        href={a.href}
                        target={a.target || '_blank'}
                        rel="noreferrer"
                        variant={variant}
                        size="sm"
                      >
                        {a.label}
                      </Button>
                    )
                  }

                  return (
                    <Button key={idx} onClick={a.onClick} variant={variant} size="sm">
                      {a.label}
                    </Button>
                  )
                })}
              </div>
            )}
          </ToastBS.Body>
        </ToastBS>
      )}

      {success && (
        <ToastBS
          className={style.toast}
          onClose={() => {
            setShow(false)
            setSuccess(null)
          }}
          show={show}
          bg={'success'}
          data-bs-theme="dark"
        >
          <ToastBS.Header>
            <div className={'w-100'}>Уведомление</div>
          </ToastBS.Header>
          <ToastBS.Body className={'text-light'}>
            {typeof success === 'string' ? (
              success
            ) : (
              <div className={'d-flex flex-column align-items-center gap-4'}>
                {success.message} <SuccessModal message={success.data} />
              </div>
            )}
          </ToastBS.Body>
        </ToastBS>
      )}
    </>
  )
}
